<div class="policy-category disabled">

  <div class="policy-item">
    <i class="policy-number">1</i>
    <radio-question [data]="payPhoneRadio.data" [valueSelected]="payPhoneRadio.valueSelected"
                    (selectAnswer)="onPayPhoneRadioQuestionSelected($event)"></radio-question>
    <select-question [data]="payPhoneSelect.data" [active]="payPhoneRadio.valueSelected === 'y'"
                     [valueSelected]="payPhoneSelect.valueSelected"
                     (selectAnswer)="onPayPhoneSelectQuestionSelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">2</i>
    <radio-question [data]="payAccountRadio.data" [valueSelected]="payAccountRadio.valueSelected"
                    (selectAnswer)="onPayAccountRadioQuestionSelected($event)"></radio-question>
    <select-question [data]="payAccountSelect.data" [active]="payAccountRadio.valueSelected === 'y'"
                     [valueSelected]="payAccountSelect.valueSelected"
                     (selectAnswer)="onPayAccountSelectQuestionSelected($event)"></select-question>
  </div>

  <div class="policy-item">
    <i class="policy-number">3</i>
    <radio-question [data]="parkedWrongRadio.data" [valueSelected]="parkedWrongRadio.valueSelected"
                    (selectAnswer)="onParkedWrongRadioQuestionSelected($event)"></radio-question>
    <select-question [data]="parkedWrongSelect.data" [active]="parkedWrongRadio.valueSelected !== 'n'"
                     [valueSelected]="parkedWrongSelect.valueSelected"
                     (selectAnswer)="onParkedWrongSelectQuestionSelected($event)"></select-question>
  </div>

  <br />
  <div class="submit-layer">
    <input aria-label=""  type="submit" class="app-submit" value="Save"
           (click)="submitPolicyCategory()" />
  </div>

</div>
